export default "/images/17cf0ca12d269413929e17ad31820bc9.avif";